// Import shared
require('./shared')

// Import components
require('../../components/photo-gallery/main')
require('../../components/price-table/main')

require('../../../js/core/component/component-api')

// Import widgets
require('../../widgets/acco-structured-data/main')
require('../../widgets/booking-gate/main')
require('../../widgets/car-rental/main')
require('../../widgets/flight-bus-selector/main')
require('../../widgets/promoted-price/main')
require('../../widgets/reviews-list/data-js-api')
require('../../widgets/room-selector/main')
require('../../widgets/selected-state/main')
require('../../widgets/room-dropdown/main')
require('../../widgets/room-list/main')
require('../../widgets/product-map/main')
require('../../widgets/subscribe-form/main')
require('../../../js/core/widget/widget-api')
require('../../widgets/acco-nav/main')

// Autoload all components when the page is ready
const { autoload } = require('../../../js/document/load-queue')
autoload()
